<template>
  <v-col :cols="cols" :md="md" class="py-2">
    <!-- Línea principal: check + botón ver -->
    <v-col cols="12" class="d-flex align-center pa-0 ma-0">
      <v-check
        v-model="localStatus"
        dense
        hide-details
        indeterminate
      >
      </v-check>

      <div
        :style="{
          cursor: fileName ? 'pointer' : 'not-allowed',
          opacity: fileName ? 1 : 0.6,
          display: 'block',
          width: '100%',
          padding: '6px 12px',
          border: '1px solid',
          borderRadius: '4px',
          textAlign: 'center',
          fontSize: '14px',
          lineHeight: '20px',
          color: localStatus === false ? 'red' : '#A96419',
          backgroundColor: 'transparent',
          fontWeight: '500',
          textTransform: 'uppercase',
          borderColor: localStatus === false ? 'red' : '#A96419',
          transition: 'all 0.3s ease',
        }"
        @click="viewDocument"
      >
        VISUALIZAR {{ clearStrings(label) }}
      </div>
    </v-col>

    <!-- Motivo de Rechazo ANTERIOR (solo lectura, si existe) -->
    <v-col
      cols="12"
      v-if="previousNote && previousNote.trim()"
      class="ma-0 pa-0 py-1"
    >
      <div class="text-caption note-style red--text">
        Motivo de Rechazo Anterior: {{ previousNote }}
      </div>
    </v-col>

    <!-- Nueva anotación SOLO si está rechazado -->
    <v-col
      cols="12"
      v-if="localStatus === false"
      class="ma-0 pa-0 py-1"
    >
      <v-textarea
        :label="textareaLabel"
        dense
        outlined
        hide-details
        v-model="localNote"
        auto-grow
        rows="1"
      ></v-textarea>
    </v-col>

    <!-- Diálogo visor -->
    <v-dialog
      v-model="dialog"
      fullscreen
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="closeDocument">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>
            Visualización de {{ clearStrings(label) }}
          </v-toolbar-title>
          
          <v-spacer></v-spacer>

          <v-btn
            text
            dark
            @click="nuevaPestana(getURL())"
          >
            <v-icon left>
              mdi-download
            </v-icon>
            Descargar Documento
          </v-btn>
        </v-toolbar>

        <v-row class="pa-0 ma-0 fill-height">
          <!-- Col izquierda: estado + notas -->
          <v-col cols="2" style="align-content: center !important;">
            <v-row class="ma-0 pa-0">
              <v-col cols="12" class="ma-0 pa-0 text-center text-subtitle-2">
                Resultado del Documento
              </v-col>

              <v-col
                cols="12"
                class="d-flex align-center pa-0 ma-0 justify-content-center"
              >
                <v-check
                  v-model="localStatus"
                  dense
                  hide-details
                  indeterminate
                >
                </v-check>
              </v-col>

              <!-- Motivo de rechazo anterior dentro del diálogo -->
              <v-col
                cols="12"
                v-if="previousNote && previousNote.trim()"
                class="ma-0 pa-0 py-1"
              >
                <div class="text-caption note-style red--text">
                  Motivo de Rechazo Anterior: {{ previousNote }}
                </div>
              </v-col>

              <!-- Nueva anotación (rechazo actual) -->
              <v-col
                cols="12"
                v-if="localStatus === false"
                class="ma-0 pa-0 py-1"
              >
                <v-textarea
                  :label="textareaLabel"
                  dense
                  outlined
                  hide-details
                  v-model="localNote"
                  auto-grow
                  rows="2"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-col>

          <!-- Col derecha: visor del documento -->
          <v-col cols="10">
            <v-row class="ma-0 pa-0 fill-height">
              <v-col cols="12" class="pa-4 fill-height">
                <!-- Loading (por si luego quieres hacerlo asíncrono) -->
                <div
                  v-if="loadingDocument"
                  class="d-flex align-center justify-center fill-height"
                >
                  <v-progress-circular
                    indeterminate
                    :size="40"
                    :width="3"
                  ></v-progress-circular>
                  <span class="ml-3 subtitle-2">
                    Cargando documento...
                  </span>
                </div>

                <!-- Error -->
                <div
                  v-else-if="loadError"
                  class="d-flex align-center justify-center fill-height red--text text-subtitle-2"
                >
                  {{ loadError }}
                </div>

                <!-- PDF -->
                <div
                  v-else-if="showPDF && url"
                  class="pdf-container"
                >
                  <vue-pdf-embed
                    class="pdf-viewer"
                    :source="url"
                  />
                </div>

                <!-- Imagen -->
                <div v-else-if="url">
                  <v-img
                    :src="url"
                    contain
                    max-height="85vh"
                  ></v-img>
                </div>

                <!-- Sin archivo -->
                <div
                  v-else
                  class="d-flex align-center justify-center fill-height grey--text text-subtitle-2"
                >
                  No hay archivo para visualizar.
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </v-col>
</template>

<script>
import VCheck from '@/components/VCheck.vue';
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed';

export default {
  name: "DocumentoRevision",
  components: {
    VCheck,
    'vue-pdf-embed': VuePdfEmbed,
  },
  props: {
    fileName: {
      type: String,
      required: false,
      default: null,
    },
    label: {
      type: String,
      required: true,
    },
    downloadUrl: {
      type: String,
      required: true,
    },
    status: {
      type: Boolean,
      default: null,
    },
    previousNote: {
      type: String,
      default: "",
    },
    note: {
      type: String,
      default: "",
    },
    textareaLabelPrevious: {
      type: String,
      default: "Motivo de Rechazo Anterior",
    },
    textareaLabel: {
      type: String,
      default: "Motivo de rechazo",
    },
    cols: {
      type: Number,
      default: 12,
    },
    md: {
      type: Number,
      default: 12,
    },
    token: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    dialog: false,
    url: null,               // URL directa al API
    showPDF: false,
    loadingDocument: false,
    loadError: null,

    localStatus: null,
    localNote: "",
  }),
  emits: ['change'],
  watch: {
    status: {
      immediate: true,
      handler(val) {
        this.localStatus = val;
      },
    },
    note: {
      immediate: true,
      handler(val) {
        this.localNote = val || "";
      },
    },
    localStatus(val) {
      if (val === true && this.localNote) {
        this.localNote = "";
      }
      this.emitChange();
    },
    localNote() {
      this.emitChange();
    },
  },
  methods: {
    emitChange() {
      this.$emit('change', {
        status: this.localStatus,
        note: this.localNote,
      });
    },

    getURL() {
      if (!this.fileName) return null;
      // Ej: /api/files/{fileName}?jwt={token}
      return `${this.downloadUrl}/${this.fileName}?jwt=${this.token}`;
    },

    getRealExtension(fileName) {
      if (!fileName) return null;
      const parts = fileName.split('.');
      if (parts.length < 2) return null;

      // si es nombre.ext.enc → tomar penúltimo
      // ej: ["ine", "pdf", "enc"] → "pdf"
      if (parts[parts.length - 1].toLowerCase() === 'enc' && parts.length >= 3) {
        return parts[parts.length - 2].toLowerCase();
      }

      // si no termina en .enc, tomar la última
      return parts[parts.length - 1].toLowerCase();
    },

    isPdfFileFromEncryptedName(fileName) {
      const ext = this.getRealExtension(fileName);
      return ext === 'pdf';
    },

    async viewDocument() {
      const url = this.getURL();
      if (!url) return;

      this.dialog = true;
      this.loadError = null;
      this.loadingDocument = false; // por si luego lo haces async

      this.showPDF = this.isPdfFileFromEncryptedName(this.fileName);
      this.url = url;
    },

    closeDocument() {
      this.dialog = false;
      // como usamos URL directa, no hay que hacer revokeObjectURL
      this.url = null;
    },

    clearStrings(inputString) {
      return inputString.replace(/ \*/g, '');
    },
    nuevaPestana(url) {
      window.open(url, "_blank");
    },
  },
};
</script>

<style scoped>
.pdf-container {
  background-color: #f5f5f5;
  padding: 16px;
  border-radius: 8px;
  max-height: 85vh;
  overflow: auto;
}

.pdf-viewer {
  width: 100%;
  height: calc(100% - 32px);
  max-height: 100%;
}

.fill-height {
  height: 100%;
}
</style>
